import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import LoaderModal from '../../../../modal/LoaderModal';
import {cekCookies} from '../../../../../actions';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import Loader from '../../../../Loader';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import ComparasiEnty from '../../../../../entity/ComparasiEnty';


import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import DropdownPaketProgram from '../../masterDropDown/DropdownPaketProgram';

class Comparasi extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,   
            isLoading : false, 
            isDicari : false,      
            kelas:[], 
            idKelas: null, 
            KelasParalelSearch :[],
            idKp : null,
            pp : [],
            idPp : null,
            tipe : null,
            namaKelasRespon : null,
            dataMapel : [],
            dataProfil : [],
            dataMaster : [],
            dataSiswa : []            
        };
    }


    async componentDidMount() {
        document.title = "Komparasi";
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
        }
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({            
            idKelas: idKelas.target.value,
            idKp : '',
            idPp : '',
            tipe : ''
        })
        
        this.setState({isFetching: true});
        this.state.KelasParalelSearch=[];
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }


    handleOnChangeKelasParalel = async (idKelasParalel) => {
        this.setState({isFetching: true});

        if(!__.isEmpty(idKelasParalel.target.value)){
            this.setState({            
                idKp: idKelasParalel.target.value
            }) 
            this.setState({            
                idPp: ''
            })


            const respPaketProg = await accountManagement.get(CONFIG.COMPARASI_PAKET_PROGRAM_BY_KELAS_PARALEL + idKelasParalel.target.value).catch (function(error){
            })  
    
            // masukan kelas paralel ke  dropdown
            if(respPaketProg){
                if(respPaketProg.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        pp: respPaketProg.data.data.dataPaketProgram
                    })
                }
            }
        }  
        this.setState({isFetching: false});
    }

    handleOnChangePP = async (idpp) => {
        if(!__.isEmpty(idpp.target.value)){
            this.setState({            
                idPp: idpp.target.value,
                tipe : ''
            })  
        }  
    }
    
    handleOnChangeTipe = async (tipe) => {
        if(!__.isEmpty(tipe.target.value)){
            this.setState({            
                tipe: tipe.target.value,
                isLoading : true
            })  
            this.setState({
                dataMapel: null,
                dataProfil: null,
                dataMaster: null,
                dataSiswa: null,
                namaKelasRespon: null,
            })
            this.setState({isDicari:false});

            if(this.state.idKelas!=null && this.state.idKp!=null && this.state.idPp!=null ){}
            const resComparasi = await accountManagement.post(CONFIG.FETCH_COMPARASI, {
                ComparasiEnty,
                    ['idKelas']: this.state.idKelas,
                    ['idKelasParalel']: this.state.idKp,
                    ['idPaketProgram']: this.state.idPp,
                    ['kodeCbt']: tipe.target.value,
                }).catch (function(error){
            }) 

            if(resComparasi){
                if(resComparasi.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        dataMapel: resComparasi.data.data.mapel,
                        dataProfil: resComparasi.data.data.profil,
                        dataMaster: resComparasi.data.data.masterData,
                        dataSiswa: resComparasi.data.data.siswa,
                        namaKelasRespon: resComparasi.data.data.kelas,
                    })
                }
            }
            if(__.isEmpty(resComparasi.data.data.mapel)){
                this.setState({isDicari:true});
            }



        }  

        this.setState({            
            isLoading : false
        })
    }
    

    loading = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }


    renderHeaderMapel(){


        if(!__.isEmpty(this.state.dataMapel)){
            var panjangMapel = this.state.dataMapel.length+1;
            return this.state.dataMapel.map((val,i) => {
                return (
                    <div className="row">
                        <div className="col-md-12">
                            <b>{val.namaMapel},</b> Kelas {this.state.namaKelasRespon}
                            <br></br>
                            <table className="table table-sm table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        <th colSpan={panjangMapel} style={{textAlign: 'center'}}>Nama Tryout</th>
                                    </tr>
                                    <tr>
                                        {this.renderPerMapel()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderSiswa(val.idMapel)}
                                </tbody>
                            </table>
                            <hr></hr>
                        </div>
                    </div>
                )
            })
        }else{
            if(this.state.isDicari){
                return(
                    <div className="row">
                        <div className="col-md-12">
                            <b className="text-center">Data tidak ketemu...</b>
                        </div>
                    </div>
                )
            }
        }
    }

    renderPerMapel(){
        if(!__.isEmpty(this.state.dataProfil)){            
            return this.state.dataProfil.map((val,i) => {
                return (
                    <th style={{textAlign: 'center'}}>
                        {val.namaProfil}
                    </th>
                )
            })           
        }
    }

    renderSiswa(idMapel){
        if(!__.isEmpty(this.state.dataSiswa)){            
            return this.state.dataSiswa.map((val,i) => {
                return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{val.namaSiswa}</td>
                        {this.renderNilaiTo(val.idSiswa, idMapel)}
                    </tr>
                )
            })           
        }
    }

    renderNilaiTo(idSiswa, idMapel){
        if(!__.isEmpty(this.state.dataMaster)){            
            return this.state.dataMaster.map((val,i) => {
                if(val.ID_SISWA == idSiswa && val.ID_MATA_PELAJARAN == idMapel){
                    return (
                        <td style={{textAlign: 'center'}}>{val.SKOR}</td>
                    )
                }
            })           
        }
    }

    render(){
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />      
                    <div className="row">
                        <div className="col-md-3">                            
                            <select className="form-control" value={this.state.selectedKelas} onChange={this.handleOnChangeKelas} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DropdownKelas kelas={this.state.kelas} />
                            </select>
                        </div>
                        <div className="col-md-3">                           
                            <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                            </select>
                        </div>
                        <div className="col-md-3">                           
                            <select className="form-control" value={this.state.idPp} onChange={this.handleOnChangePP} required>
                                <option value="" selected disabled>~~ Pilih Paket Program ~~</option>
                                <DropdownPaketProgram pp={this.state.pp} />
                            </select>
                        </div>
                        <div className="col-md-3">                           
                            <select className="form-control" value={this.state.tipe} onChange={this.handleOnChangeTipe} required>
                                <option value="" selected disabled>~~ Pilih Type Tryout ~~</option>
                                <option value="TOO" >TOO</option>
                                <option value="AGCU" >AGCU</option>                                
                            </select>
                        </div>
                    </div> 
                    
                    <br></br>
                    {this.loading()}
                        {this.renderHeaderMapel()}
                    {this.loading()}
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Comparasi);